<!--
 * @Author: fengqianhui
 * @Date: 2024-01-08 14:36:16
 * @LastEditors: 18518155760 111m
 * @LastEditTime: 2024-01-17 17:02:55
 * @FilePath: \landingpage\src\views\build\components\QrCode.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <canvas class="canvas" ref="canvasRef"></canvas>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import QRCode from 'qrcode';
import { useOriginDataStore } from '@/stores/originDataStore';
const store = useOriginDataStore();
const originData = computed(() => store.data);
const link = ref('');
watch(
  originData,
  (newVal) => {
    if (newVal) {
      link.value = newVal.qrCodeUrl || '';
    }
  },
  { immediate: true, deep: true },
);
const canvasRef = ref<HTMLCanvasElement | null>(null);
onMounted(() => {
  if (canvasRef.value && originData.value) {
    const options = {
      errorCorrectionLevel: 'H',
      margin: 5,
      scale: 4,
      width: 250, // 设置生成二维码图片的宽度(实际大小受到canvas样式影响)
      color: {
        dark: '#000000', // 二维码的颜色
        light: '#FFFFFF', // 二维码背景的颜色
      },
    };
    QRCode.toCanvas(canvasRef.value, link.value, options, (error: Error | null) => {
      if (error) console.error('Error generating QR Code: ', error);
    });
  }
});
</script>
